module.exports = __webpack_public_path__ + "images/logo-xmas-a581c5ea1091f4519036c0f07bd2bdfa.gif";